import { render, staticRenderFns } from "./listarGrupos.vue?vue&type=template&id=7f9c10bb&scoped=true"
import script from "./listarGrupos.vue?vue&type=script&lang=js"
export * from "./listarGrupos.vue?vue&type=script&lang=js"
import style0 from "./listarGrupos.vue?vue&type=style&index=0&id=7f9c10bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c10bb",
  null
  
)

export default component.exports